'use client'

import { useEffect } from 'react'

interface Props {
  sessionId: string
  serviceSlug: string
  serviceName: string
  totalPrice?: string
  customerName?: string
}

/**
 * Fires `purchase_service` in PostHog exactly once after confirmed payment.
 * Uses sessionStorage keyed on the Stripe session_id to prevent re-firing
 * if the user refreshes the success page or navigates back to it.
 */
export default function SuccessTracking({
  sessionId,
  serviceSlug,
  serviceName,
  totalPrice,
  customerName,
}: Props) {
  useEffect(() => {
    if (!sessionId) return

    const storageKey = `ph_tracked_${sessionId}`
    if (sessionStorage.getItem(storageKey)) return

    sessionStorage.setItem(storageKey, '1')

    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'ph_purchase_service',
        serviceSlug,
        serviceName,
        totalPrice: totalPrice ? parseFloat(totalPrice) : undefined,
        customerName,
      })
    }
  }, [sessionId, serviceSlug, serviceName, totalPrice, customerName])

  return null
}
